import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";

import { Logo } from "@/components/server-shell";
import { authClient } from "@/lib/auth-client";
import { orpc } from "@/utils/orpc";

import UserMenu from "./user-menu";

const NAV = "inline-flex min-h-9 items-center rounded-md px-3 no-underline";
const ACTIVE = { className: "bg-[#222220] font-medium text-[#ECEAE4]" };
const INACTIVE = { className: "text-[#A8A59D] hover:text-[#ECEAE4]" };

/** The account bar above Servers, Cloud tokens and Admin (a server's pages use their sidebar instead). */
export default function Header() {
  const { data: session } = authClient.useSession();
  const admin = session?.user.role === "admin";
  const users = useQuery({ ...orpc.admin.users.queryOptions(), enabled: admin });
  const waiting = users.data?.filter((u) => !u.approved && u.role !== "admin").length ?? 0;

  return (
    <header className="flex flex-wrap items-center justify-between gap-4 border-b border-[#262523] bg-[#0C0C0B] px-5 py-3.5 sm:px-10">
      <div className="flex flex-wrap items-center gap-7">
        <Link to={session ? "/servers" : "/"} className="flex items-center gap-2.5 text-[#ECEAE4] no-underline">
          <Logo />
          <span className="font-mono text-[15px] font-bold">Fieldwork</span>
        </Link>
        {session && (
          <nav aria-label="Account" className="flex flex-wrap gap-1 text-sm">
            <Link to="/servers" className={NAV} activeProps={ACTIVE} inactiveProps={INACTIVE}>
              Servers
            </Link>
            <Link to="/tokens" className={NAV} activeProps={ACTIVE} inactiveProps={INACTIVE}>
              Cloud tokens
            </Link>
            {admin && (
              <Link to="/admin" className={NAV} activeProps={ACTIVE} inactiveProps={INACTIVE}>
                Admin
                {waiting > 0 && (
                  <span
                    aria-label={`${waiting} waiting for approval`}
                    className="ml-1.5 rounded-lg bg-[#FF4F1A] px-1.5 py-px font-mono text-[11px] text-[#111111]"
                  >
                    {waiting}
                  </span>
                )}
              </Link>
            )}
          </nav>
        )}
      </div>
      <UserMenu />
    </header>
  );
}
